import { PUBLISH_STATES } from "../../../constants";
import { Checkbox, Dialog, Text, TextField } from "@merge-api/merge-javascript-shared";

type Props = {
  isShown: boolean;
  onHide: () => void;
  publishIntent: string;
  publishAction: () => void;
  asanaTicketField: string;
  setAsanaTicketField: (asanaTicketField: string) => void;
  changelogCommentField: string;
  setChangelogCommentField: (changelogCommentField: string) => void;
  resetTimestampsOnPublish: boolean;
  setResetTimestampsOnPublish: (resetTimestamps: boolean) => void;
  isLoading: boolean;
};

const ChangelogPublishModal = ({
  isShown,
  onHide,
  publishIntent,
  publishAction,
  asanaTicketField,
  setAsanaTicketField,
  changelogCommentField,
  setChangelogCommentField,
  resetTimestampsOnPublish,
  setResetTimestampsOnPublish,
  isLoading,
}: Props) => {
  const onClose = () => {
    onHide();
    setChangelogCommentField("");
    setAsanaTicketField("");
  };

  return (
    <Dialog
      open={isShown}
      onClose={onClose}
      title={
        publishIntent === PUBLISH_STATES.PUBLISHED ? "Publish blueprint" : "Unpublish blueprint"
      }
      primaryButtonText={publishIntent === PUBLISH_STATES.PUBLISHED ? "Publish" : "Unpublish"}
      primaryButtonDisabled={!asanaTicketField || !changelogCommentField}
      onPrimaryButtonClick={publishAction}
      primaryButtonLoading={isLoading}
      secondaryButtonText="Cancel"
      onSecondaryButtonClick={onClose}
      variant="md"
    >
      <div className="flex flex-col gap-y-6">
        <TextField
          onChange={(e) => {
            setAsanaTicketField(e.target.value);
          }}
          value={asanaTicketField}
          labelTitle="Enter your Asana ticket URL"
        />
        <TextField
          onChange={(e) => {
            setChangelogCommentField(e.target.value);
          }}
          value={changelogCommentField}
          labelTitle="Enter any comments you have regarding the change you're making"
        />
        {publishIntent === PUBLISH_STATES.UNPUBLISHED && (
          <Text className={"text-red-50"}>
            By pressing "Unpublish", you understand that to revert a change, you must first
            unpublish this version then manually publish the correct version. Merge backend will not
            automatically revert to the last recently published version when you unpublish this
            version.
          </Text>
        )}
        {publishIntent === PUBLISH_STATES.PUBLISHED && (
          <Checkbox
            label="Reset timestamps and global variables on publish"
            checked={resetTimestampsOnPublish}
            onChange={() => setResetTimestampsOnPublish(!resetTimestampsOnPublish)}
          />
        )}
      </div>
    </Dialog>
  );
};

export default ChangelogPublishModal;
